import { cn } from '@virginexperiencedays/tailwind';

import { AddToBasket as AddToBasketV1, type AddToBasketProps } from './';

export const AddToBasket = ({ className, error, ...rest }: AddToBasketProps) => (
  <AddToBasketV1
    className={cn(
      'm-0 md:m-0',
      'min-h-14 px-4 py-[18px]',
      'border-0 text-lg leading-[20px]',
      error && styles.error,
      className
    )}
    error={error}
    {...rest}
  />
);

export const styles = {
  error: 'text-brand bg-primary-100 focus:bg-primary-100 hover:bg-primary-50',
};
